export default {
  seats: [],
  participantsSeat: [],
  pagination: {},
  paginationP: {},
  seat: {}
}
